import React from 'react'
import './input-text.scss'

export const InputText = ({
  label,
  name,
  register,
  type = 'text',
  validations = {},
  errors = {},
  messageError,
  resetError,
  hidden = false,
  edgeStatus = false,
  setPasswordStatus,
  className = '',
  color = '',
  ...props
}) => {
  return (
    <div className={`f-input-text ${color} ${className} `} hidden={hidden}>
      {label && (
        <label className="f-input-text__label" htmlFor="input">
          {label}
        </label>
      )}

      <input
        className="f-input-text__field"
        onFocus={messageError && resetError}
        type={type}
        {...props}
        {...register(name, validations)}
      />
      {(type === 'password' || edgeStatus) && (
        <div className="f-input-text__edge"></div>
      )}

      {register && ((errors && errors[name]) || messageError) && (
        <span className="f-input-text__error">
          {errors[name].message || messageError}
        </span>
      )}
    </div>
  )
}
